import React, { useState, useEffect } from 'react';

const NecrovaTerminal = () => {
  const [power, setPower] = useState(false);
  const [bootStage, setBootStage] = useState(0);
  const [currentTime, setCurrentTime] = useState('');
  const [activeWindow, setActiveWindow] = useState(null);
  const [jobs, setJobs] = useState([
    {
      id: 1,
      title: 'Quantum AI Engineer',
      department: 'R&D Division',
      description: 'Design and implement next-generation quantum-based artificial intelligence systems for classified Necrova projects.',
      requirements: [
        'PhD in Quantum Computing, Artificial Intelligence, or related field',
        'Min. 5 years experience with quantum neural networks',
        'Security clearance level 4 or higher',
        'Willingness to sign extended NDA agreements'
      ]
    },
    {
      id: 2,
      title: 'Biomechanical Integration Specialist',
      department: 'Advanced Cybernetics',
      description: 'Lead the development of human-machine interfaces for our proprietary neural enhancement systems.',
      requirements: [
        'Advanced degree in Biomedical Engineering',
        'Experience with neural implant technology',
        'Programming skills in C++ and BioScript',
        'Knowledge of FDA/regulatory submission process'
      ]
    },
    {
      id: 3,
      title: 'Security Protocols Officer',
      department: 'Information Security',
      description: 'Maintain and enhance network security across all Necrova facilities, with focus on quantum encryption protocols.',
      requirements: [
        'CISSP, CISM, or equivalent certification',
        'Background in military or government security',
        'Experience with quantum-resistant cryptography',
        'Ability to work under pressure in crisis situations'
      ]
    }
  ]);

  useEffect(() => {
    if (power) {
      // Boot sequence
      const bootInterval = setInterval(() => {
        if (bootStage < 5) {
          setBootStage(prevStage => prevStage + 1);
        } else {
          clearInterval(bootInterval);
        }
      }, 1000);

      // Clock update
      const timeInterval = setInterval(() => {
        const now = new Date();
        setCurrentTime(now.toLocaleTimeString('en-US', { hour12: false }));
      }, 1000);

      return () => {
        clearInterval(bootInterval);
        clearInterval(timeInterval);
      };
    } else {
      setBootStage(0);
    }
  }, [power, bootStage]);

  const togglePower = () => {
    setPower(!power);
  };

  const renderBootSequence = () => {
    switch(bootStage) {
      case 0:
        return (
          <div className="boot-screen">
          </div>
        );
      case 1:
        return (
          <div className="boot-screen">
            <div className="boot-text">INITIALIZING SYSTEM</div>
            <div className="progress-bar">
              <div className="progress" style={{ width: '20%' }}></div>
            </div>
          </div>
        );
      case 2:
        return (
          <div className="boot-screen">
            <div className="boot-text">LOADING CORE MODULES</div>
            <div className="progress-bar">
              <div className="progress" style={{ width: '40%' }}></div>
            </div>
            <div className="boot-info">
              MEMORY CHECK: OK<br/>
              CPU: NECROVA QUANTUM PROCESSOR<br/>
              INITIALIZING VIRTUAL ENVIRONMENT...
            </div>
          </div>
        );
      case 3:
        return (
          <div className="boot-screen">
            <div className="boot-text">ESTABLISHING SECURE CONNECTION</div>
            <div className="progress-bar">
              <div className="progress" style={{ width: '70%' }}></div>
            </div>
            <div className="boot-info">
              ENCRYPTION: ENABLED<br/>
              FIREWALL: ACTIVE<br/>
              NECROVA PROTOCOLS: LOADING...
            </div>
          </div>
        );
      case 4:
        return (
          <div className="boot-screen">
            <div className="boot-text">PREPARING DESKTOP ENVIRONMENT</div>
            <div className="progress-bar">
              <div className="progress" style={{ width: '90%' }}></div>
            </div>
          </div>
        );
      default:
        return renderDesktop();
    }
  };

  const renderDesktop = () => {
    return (
      <div className="desktop">
        <div className="desktop-icons">
          <div className="icon" onClick={() => setActiveWindow('hiring')}>
            <div className="icon-img hiring-icon"></div>
            <div className="icon-text">Hiring Portal</div>
          </div>
          <div className="icon">
            <div className="icon-img email-icon"></div>
            <div className="icon-text">Email</div>
          </div>
          <div className="icon">
            <div className="icon-img network-icon"></div>
            <div className="icon-text">Network</div>
          </div>
          <div className="icon">
            <div className="icon-img security-icon"></div>
            <div className="icon-text">Security</div>
          </div>
        </div>

        {activeWindow === 'hiring' && (
          <div className="window hiring-window">
            <div className="window-title">
              <div className="title-text">NECROVA INDUSTRIES - Hiring Portal v3.12</div>
              <div className="window-controls">
                <span className="window-button minimize">_</span>
                <span className="window-button maximize">□</span>
                <span className="window-button close" onClick={() => setActiveWindow(null)}>×</span>
              </div>
            </div>
            <div className="window-menu">
              <div className="menu-item">File</div>
              <div className="menu-item">Edit</div>
              <div className="menu-item">View</div>
              <div className="menu-item">Options</div>
              <div className="menu-item">Security</div>
              <div className="menu-item">Help</div>
            </div>
            <div className="window-content">
              <div className="hiring-header">
                <div className="hiring-logo">NECROVA</div>
                <div className="hiring-subtitle">CAREER OPPORTUNITIES</div>
                <div className="hiring-status">
                  SECURE CONNECTION: ESTABLISHED | CLEARANCE LEVEL: STANDARD
                </div>
              </div>
              <div className="hiring-body">
              </div>
              <div className="hiring-footer">
                <div className="footer-text">NECROVA INDUSTRIES • ALL RIGHTS RESERVED • {new Date().getFullYear()}</div>
                <div className="system-message">NETWORK STATUS: SECURE • USER ACCESS: MONITORED</div>
              </div>
            </div>
          </div>
        )}

        <div className="taskbar">
          <div className="start-button">
          <img 
  src="https://cdn.4fingerstudios.com/Necrova/NecrovaStuffas/Full.png" 
  alt="Logo" 
  className="computer-logo" 
  style={{ width: "25px", height: "auto" }} 
/>
          </div>
          {activeWindow && (
            <div className="taskbar-item active">
              <span className="taskbar-icon"></span>
              <span className="taskbar-text">NECROVA Hiring Portal</span>
            </div>
          )}
          <div className="taskbar-right">
            <div className="taskbar-clock">{currentTime}</div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className="terminal-container">
      <div className="computer-case">
        <div className="monitor">
          <div className="screen">
            {renderBootSequence()}
          </div>
        </div>
        <div className="computer-base">
          <div className="power-button" onClick={togglePower}>
            {power ? 'O' : 'I'}
          </div>
          <div className="drive-bay">A:</div>
          <div className="drive-bay">C:</div>
          <img 
  src="https://cdn.4fingerstudios.com/Necrova/NecrovaStuffas/NECROVA.png" 
  alt="Logo" 
  className="computer-logo" 
  style={{ width: "200px", height: "auto" }} 
/>

        </div>
      </div>
      <style jsx>{`
        .terminal-container {
          font-family: 'MS Sans Serif', 'Courier New', monospace;
          display: flex;
          justify-content: center;
          align-items: center;
          background-color: #121212;
          min-height: 100vh;
          perspective: 800px;
        }

        .computer-case {
          background-color: #d4d0c8;
          border: 2px solid #a0a0a0;
          border-radius: 5px;
          box-shadow: 0 10px 30px rgba(0, 0, 0, 0.8);
          width: 90%;
          max-width: 900px;
          transform: rotateX(5deg);
        }

        .monitor {
          background-color: #888;
          border: 8px solid #444;
          border-radius: 5px;
          padding: 10px;
          margin: 20px;
        }

        .screen {
          background-color: #000;
          width: 100%;
          height: 500px;
          overflow: hidden;
          position: relative;
          border: 1px solid #222;
          box-shadow: inset 0 0 10px rgba(0, 128, 0, 0.3);
        }

        .computer-base {
          display: flex;
          align-items: center;
          padding: 10px 20px;
          border-top: 2px solid #a0a0a0;
        }

        .power-button {
          background-color: #444;
          color: white;
          width: 30px;
          height: 30px;
          border-radius: 50%;
          display: flex;
          justify-content: center;
          align-items: center;
          margin-right: 15px;
          font-weight: bold;
          cursor: pointer;
          box-shadow: inset 0 0 5px rgba(255, 255, 255, 0.3);
          border: 1px solid #222;
        }

        .drive-bay {
          background-color: #333;
          color: #ccc;
          padding: 5px 10px;
          margin: 0 10px;
          border-radius: 3px;
          font-size: 12px;
        }

        .computer-logo {
          margin-left: auto;
          font-size: 14px;
          color: #444;
          font-weight: bold;
          letter-spacing: 1px;
        }

        /* Boot screens */
        .boot-screen {
          width: 100%;
          height: 100%;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          color: #00aa00;
          background-color: #000;
        }

        .necrova-logo {
          font-size: 36px;
          font-weight: bold;
          letter-spacing: 3px;
          margin-bottom: 30px;
          text-shadow: 0 0 10px rgba(0, 170, 0, 0.7);
        }

        .boot-text {
          font-size: 18px;
          margin-bottom: 20px;
        }

        .boot-info {
          font-family: 'Courier New', monospace;
          font-size: 12px;
          text-align: left;
          margin-top: 20px;
          max-width: 500px;
          align-self: center;
        }

        .progress-bar {
          width: 300px;
          height: 15px;
          background-color: #333;
          border: 1px solid #555;
        }

        .progress {
          height: 100%;
          background-color: #00aa00;
        }

        /* Desktop styling */
        .desktop {
          width: 100%;
          height: 100%;
          background-color: #008080;
          position: relative;
          overflow: hidden;
        }

        .desktop-icons {
          padding: 10px;
          display: grid;
          grid-template-columns: repeat(auto-fill, 70px);
          gap: 10px;
        }

        .icon {
          width: 70px;
          height: 80px;
          display: flex;
          flex-direction: column;
          align-items: center;
          cursor: pointer;
        }

        .icon-img {
          width: 40px;
          height: 40px;
          background-color: #c3c3c3;
          border: 1px solid #000;
          margin-bottom: 5px;
        }

        .icon-text {
          color: white;
          font-size: 12px;
          text-align: center;
          text-shadow: 1px 1px 1px #000;
        }

        .hiring-icon {
          background-color: #a020f0;
        }

        .email-icon {
          background-color: #4169e1;
        }

        .network-icon {
          background-color: #228b22;
        }

        .security-icon {
          background-color: #b22222;
        }

        /* Windows */
        .window {
          position: absolute;
          top: 50px;
          left: 50px;
          width: 80%;
          height: 75%;
          background-color: #c0c0c0;
          border: 2px outset #fff;
          box-shadow: 2px 2px 10px rgba(0, 0, 0, 0.5);
          display: flex;
          flex-direction: column;
        }

        .window-title {
          background: linear-gradient(90deg, #000080, #1084d0);
          color: white;
          font-weight: bold;
          padding: 4px 8px;
          display: flex;
          justify-content: space-between;
          align-items: center;
        }

        .window-controls {
          display: flex;
        }

        .window-button {
          width: 16px;
          height: 16px;
          background-color: #c0c0c0;
          border: 1px outset #fff;
          display: flex;
          justify-content: center;
          align-items: center;
          font-size: 12px;
          margin-left: 2px;
          cursor: pointer;
        }

        .window-menu {
          display: flex;
          background-color: #c0c0c0;
          border-bottom: 1px solid #808080;
        }

        .menu-item {
          padding: 2px 8px;
          font-size: 12px;
        }

        .menu-item:hover {
          background-color: #000080;
          color: white;
        }

        .window-content {
          flex: 1;
          padding: 10px;
          background-color: #ededed;
          overflow: auto;
          display: flex;
          flex-direction: column;
        }

        .window-statusbar {
          height: 20px;
          background-color: #c0c0c0;
          border-top: 1px solid #808080;
          display: flex;
          padding: 2px 5px;
          font-size: 11px;
        }

        .status-items, .status-memory, .status-cpu {
          margin-right: 15px;
        }

        /* Taskbar */
        .taskbar {
          position: absolute;
          bottom: 0;
          left: 0;
          width: 100%;
          height: 28px;
          background-color: #c0c0c0;
          border-top: 1px solid #fff;
          display: flex;
          align-items: center;
          padding: 0 2px;
        }

        .start-button {
          background-color: #c0c0c0;
          border: 1px outset #fff;
          padding: 1px 5px;
          margin-right: 5px;
          display: flex;
          align-items: center;
          font-weight: bold;
          font-size: 12px;
          height: 22px;
        }

        .start-logo {
          background-color: #a020f0;
          color: white;
          width: 16px;
          height: 16px;
          display: flex;
          justify-content: center;
          align-items: center;
          margin-right: 4px;
          font-size: 12px;
          font-weight: bold;
        }

        .taskbar-item {
          background-color: #c0c0c0;
          border: 1px outset #fff;
          height: 22px;
          min-width: 150px;
          margin-right: 3px;
          font-size: 11px;
          display: flex;
          align-items: center;
          padding: 0 5px;
        }

        .taskbar-item.active {
          border: 1px inset #fff;
          background-color: #c0c0c0;
        }

        .taskbar-right {
          margin-left: auto;
          display: flex;
        }

        .taskbar-clock {
          border: 1px inset #fff;
          padding: 1px 5px;
          height: 22px;
          display: flex;
          align-items: center;
          font-size: 11px;
        }

        /* Hiring Portal Content */
        .hiring-header {
          text-align: center;
          margin-bottom: 15px;
          border-bottom: 2px groove #fff;
          padding-bottom: 10px;
        }

        .hiring-logo {
          font-size: 24px;
          font-weight: bold;
          color: #000080;
          letter-spacing: 2px;
        }

        .hiring-subtitle {
          font-size: 14px;
          color: #808080;
          margin-top: 5px;
        }

        .hiring-status {
          font-size: 10px;
          font-family: 'Courier New', monospace;
          color: #444;
          margin-top: 10px;
          background-color: #ddd;
          padding: 3px;
          border: 1px inset #ccc;
        }

        .hiring-body {
          flex: 1;
          overflow-y: auto;
        }

        .jobs-list {
          display: flex;
          flex-direction: column;
          gap: 15px;
        }

        .job-listing {
          background-color: #f0f0f0;
          border: 1px solid #a0a0a0;
          padding: 10px;
        }

        .job-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 10px;
          border-bottom: 1px solid #ccc;
          padding-bottom: 5px;
        }

        .job-title {
          font-weight: bold;
          color: #000080;
        }

        .job-department {
          font-size: 11px;
          background-color: #e0e0e0;
          padding: 2px 5px;
          border: 1px solid #ccc;
        }

        .job-description {
          font-size: 12px;
          margin-bottom: 10px;
        }

        .requirements-title {
          font-weight: bold;
          font-size: 12px;
          margin-bottom: 5px;
        }

        .requirements-list {
          font-size: 12px;
          margin: 0;
          padding-left: 20px;
        }

        .requirements-list li {
          margin-bottom: 5px;
        }

        .apply-button {
          background-color: #000080;
          color: white;
          border: 1px outset #1084d0;
          padding: 5px 10px;
          font-size: 12px;
          cursor: pointer;
          margin-top: 10px;
          width: 100%;
        }

        .apply-button:active {
          border: 1px inset #1084d0;
        }

        .hiring-footer {
          margin-top: 15px;
          border-top: 2px groove #fff;
          padding-top: 10px;
          font-size: 10px;
          text-align: center;
        }

        .footer-text {
          color: #555;
          margin-bottom: 5px;
        }

        .system-message {
          font-family: 'Courier New', monospace;
          color: #a020f0;
          font-size: 9px;
        }
      `}</style>
    </div>
  );
};

export default NecrovaTerminal;